import React, { FC } from 'react';
import { Outlet, useParams } from 'react-router';

import { useAdminUserInfoStream } from './hooks/useAdminUserInfoStream';

import { Header } from '@/widgets/header';
import { Footer } from '@/widgets/footer';
import { Layout } from '@/shared/ui';


export const UserContainer: FC = () => {
  const { userID } = useParams<{ userID: string }>();

  useAdminUserInfoStream(userID);

  return (
    <Layout>
      <Header />
      <Outlet />
      <Footer />
    </Layout>
  );
};
